import React from 'react';
import { ReferralType, getReferralStatusColorClass, getReferralStatusName } from '~/util';

interface ReferralStatusBadgeProps {
    referral: ReferralType;
}
export function ReferralStatusBadge({ referral }: ReferralStatusBadgeProps) {
    return (
        <span className={`referral-status me-3 badge ${getReferralStatusColorClass(referral)}`}>
            <span title={referral.custom_status?.expose ? referral.custom_status.name : undefined}>
                {getReferralStatusName(referral)}&nbsp;
                {!!referral.custom_status?.expose && <i className="fa-solid fa-question-circle" />}
            </span>
            {referral.failed_transmissions_count > 0 && (
                <i
                    title={`${referral.failed_transmissions_count} ${
                        referral.failed_transmissions_count > 1 ? 'communications' : 'communication'
                    } failed`}
                    className="fa-solid fa-exclamation-triangle text-warning ms-1"
                />
            )}
        </span>
    );
}
